import { Component, OnInit, Input } from '@angular/core';
import { ControlStatusService } from '../shared/control-status.service';
import { RelatoriosDashboardCardComponent } from '../relatorios-dashboard-card/relatorios-dashboard-card.component';

@Component({
    selector: 'popup-relatorios',
    templateUrl: './popup-relatorios.component.html',
    styleUrls: ['./popup-relatorios.component.css'],
    standalone: true,
    imports: [RelatoriosDashboardCardComponent]
})
export class PopupRelatoriosComponent implements OnInit {

  constructor(private controlStatus: ControlStatusService) { }

  ngOnInit() {
  }

  
}
